import { defineMessages } from '@kyruus/intl';

export const messages = defineMessages({
  providerListHeader: {
    id: 'providerlist.header',
    description: 'Header for a list of search results ',
    defaultMessage: 'Search results'
  },
  providerListExpandedSearchRadiusFullWarning: {
    id: 'providerlist.expanded_search_radius_full_warning',
    description:
      'Warning message that the distance filter was removed when no results are found for a provided search radius and even within a 100 mile radius',
    defaultMessage: `No providers found near the selected location, showing all results for "{searchDescription}"`
  },
  providerListExpandedSearchRadiusPartialWarning: {
    id: 'providerlist.expanded_search_radius_partial_warning',
    description:
      'Warning message when no results are found and the search radius is automatically expanded to get results',
    defaultMessage: `No providers found within {
        originalDistance,
        plural,
        one {# mile}
        other {# miles}
      }, showing providers within {expandedDistance, select, Any {any miles} any {any miles} other {{expandedDistance, plural, one {# mile} other {# miles}}}}
      `
  },
  alertCloseButtonAriaLabel: {
    id: 'banner.close.arialLabel1',
    description:
      'action1 close icon aria label text to be read by screen reader',
    defaultMessage: 'close'
  },
  noResultsBanner: {
    id: 'banner.noProvidersFound',
    description: 'Banner displayed when no providers are found',
    defaultMessage:
      'We are unable to locate any providers based on your search area. Try searching in a different area.'
  },

  clinical_keywords: {
    id: 'search.searchtypes.clinical_keywords',
    description: 'Category name for a suggested `clinical_keywords` search',
    defaultMessage: 'Conditions'
  },
  location_name: {
    id: 'search.searchtypes.location_name',
    description: 'Category name for a suggested `location_name` search',
    defaultMessage: 'Locations'
  },
  mapSearchLinkText: {
    id: 'map_search.map_search_link.text',
    description: 'Text of the link that opens the map search page',
    defaultMessage: 'Map'
  },
  mapSearchLinkAriaLabel: {
    id: 'map_search.map_search_link.aria_label',
    description: 'Aria label of the link that opens the map search page',
    defaultMessage: 'Map Search'
  },
  network_affiliation: {
    id: 'search.searchtypes.network_affiliation',
    description: 'Category name for a suggested `network_affiliation` search',
    defaultMessage: 'Affiliations'
  },
  provider_name: {
    id: 'search.searchtypes.provider_name',
    description: 'Category name for a suggested `provider_name` search',
    defaultMessage: 'Providers'
  },
  specialties: {
    id: 'search.searchtypes.specialties',
    description: 'Category name for a suggested `specialties` search',
    defaultMessage: 'Specialties'
  },
  closeLocationDetailsAriaLabel: {
    id: 'map_search.location_details.aria.label.close',
    description: 'Aria label for close location details',
    defaultMessage: 'Close location details'
  }
});
